exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".prebuild-series[data-v-a5e757e8] {\n  font-family: \"Akkurat-Pro\";\n  overflow-x: hidden;\n}", ""]);

// exports
